import React, { useEffect, useState } from "react";
import previewIcon from "assets/illustrations/invitation.png";
import gymoIcon from "assets/icons/gymo_logo_with_lettering.png";
import UserStore from "stores/user.store";
import { inject, observer } from "mobx-react";
import ComponentWrapper from "components/general.compoenents/component.wrapper.component/component.wrapper.component";
import SizedContainer from "components/general.compoenents/sized.container.component/sized.container.component";
import { ContainerSizes } from "globals/enums/global.enum";
import { RunningText } from "components/text.components/running.text.component/running.text.component";
import Row from "components/general.compoenents/row.component/row.component";
import FilledButton from "components/input.components/filled.button.component/filled.button.component";
import LinkButton from "components/input.components/link.button.component/link.button.component";
import "./handle.invitation.page.scss";
import SmallHeadline from "components/text.components/small.headline.component/small.headline.component";
import Column from "components/general.compoenents/column.component/column.component";
import { HttpInvitationService } from "services/httpClients/http.invitation.client";
import { useNavigate } from "react-router";
import { HttpAuthService } from "services/httpClients/http.auth.client";
import Headline from "components/text.components/headline.component/headline.component";

interface HandleInvitationPageProps {
  userStore?: UserStore;
}

const HandleInvitationPage = ({
  userStore,
}: HandleInvitationPageProps): JSX.Element => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const invitations = userStore?.studioUserInvitations;

  useEffect(() => {
    userStore?.fetchAndSetUserStudioInvitations();
  }, []);

  const acceptStudioInvitation = async (
    invitationId: string
  ): Promise<void> => {
    setIsLoading(true);
    await HttpInvitationService.getInstance().acceptInvitation(invitationId);
    await HttpAuthService.getInstance().refreshToken();
    setIsLoading(false);
    navigate("/");
  };

  const declineStudioInvitation = async (
    invitationId: string
  ): Promise<void> => {
    setIsLoading(true);
    await HttpInvitationService.getInstance().declineInvitation(invitationId);
    setIsLoading(false);
    navigate("/");
  };

  const _buildHandleInvitationContent = (): JSX.Element => {
    return (
      <Column justifyContent="center" alignItems="center">
        {invitations?.data.map((invitation, index) => (
          <SizedContainer
            className="mb-15"
            key={`invitation-${index}`}
            size={ContainerSizes.M}
          >
            <ComponentWrapper>
              <SmallHeadline>{invitation.resource?.name}</SmallHeadline>
              <RunningText>
                Du wurdest eingeladen {invitation.resource?.name} beizutreten.
              </RunningText>
              <Row
                className="mt-15"
                justifyContent="space-between"
                alignItems="center"
              >
                <LinkButton
                  className="decline-button"
                  label="Ablehnen"
                  disabled={isLoading}
                  onClick={() => {
                    if (invitation._id == null) {
                      return;
                    }
                    declineStudioInvitation(invitation._id);
                  }}
                />
                <FilledButton
                  isLoading={isLoading}
                  label="Akzeptieren"
                  onClick={() => {
                    if (invitation._id == null) {
                      return;
                    }
                    acceptStudioInvitation(invitation._id);
                  }}
                />
              </Row>
            </ComponentWrapper>
          </SizedContainer>
        ))}
      </Column>
    );
  };

  const _buildPreview = (): JSX.Element => {
    return (
      <div className="handle-invitation-preview-container">
        <img className="gymo-logo" src={gymoIcon} />
        <Headline className="handle-invitation-header">{`The biggest smallest\nFitness Software.`}</Headline>
        <img className="handle-invitation-preview-image" src={previewIcon} />
      </div>
    );
  };

  return (
    <Row className="handle-invitation-page">
      <div className="handle-invitation-page-wrapper">
        {_buildPreview()}
        <div className="handle-invitation-form-wrapper">
          {_buildHandleInvitationContent()}
        </div>
      </div>
    </Row>
  );
};

export default inject("userStore")(observer(HandleInvitationPage));
